import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  FormControl,
  FormGroup,
  FormControlLabel,
  DialogActions,
  Typography,
  Switch,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";

const GatewayModal = ({
  classes,
  item,
  isOpen,
  handleClose,
  handleGatewayChange,
  action,
}) => {
  const [dataObj, setDataObj] = useState(
    item
      ? item
      : {
          user_name: "",
          password: "",
          customer_code: "",
          processor_name: "",
          in_use: false,
        }
  );
  const [isvalid, setIsvalid] = useState({
    valid: item ? true : false,
    user_name: {
      valid: true,
      error: "",
    },
    password: {
      valid: true,
      error: "",
    },
    customer_code: {
      valid: true,
      error: "",
    },
    processor_name: {
      valid: true,
      error: "",
    },
  });
  const onInputChange = (e) => {
    let { name, value } = e.target;
    setDataObj({ ...dataObj, [name]: value });
    validationHandler(name, value);
  };

  const validationHandler = (name, value) => {
    switch (name) {
      case "user_name":
        if (value.length < 3) {
          setIsvalid({
            ...isvalid,
            valid: checkOverallValid(name, false),
            user_name: { valid: false, error: "Invalid User Name!" },
          });
        } else {
          setIsvalid({
            ...isvalid,
            valid: checkOverallValid(name, true),
            user_name: { valid: true, error: "" },
          });
        }
        break;
      case "password":
        if (value.length < 9) {
          setIsvalid({
            ...isvalid,
            valid: checkOverallValid(name, false),
            password: {
              valid: false,
              error: "Password should be more than 8 character!",
            },
          });
        } else {
          setIsvalid({
            ...isvalid,
            valid: checkOverallValid(name, true),
            password: { valid: true, error: "" },
          });
        }
        break;
      case "customer_code":
        if (value.length < 3) {
          setIsvalid({
            ...isvalid,
            valid: checkOverallValid(name, false),
            customer_code: { valid: false, error: "Invalid code!" },
          });
        } else {
          setIsvalid({
            ...isvalid,
            valid: checkOverallValid(name, true),
            customer_code: { valid: true, error: "" },
          });
        }
        break;
      case "processor_name":
        if (value.length < 3) {
          setIsvalid({
            ...isvalid,
            valid: checkOverallValid(name, false),
            processor_name: { valid: false, error: "Invalid Processor Name!" },
          });
        } else {
          setIsvalid({
            ...isvalid,
            valid: checkOverallValid(name, true),
            processor_name: { valid: true, error: "" },
          });
        }
        break;
      default:
        return;
    }
  };

  const checkInitialState = (current) => {
    for (let i in dataObj) {
      if (i !== current && i !== "in_use" && dataObj[i].length < 1) {
        return false;
      }
    }
    return true;
  };
  const checkOverallValid = (name, status) => {
    switch (name) {
      case "user_name":
        if (
          checkInitialState(name).valueOf(true) &&
          status &&
          isvalid.password.valid &&
          isvalid.customer_code.valid &&
          isvalid.processor_name.valid
        ) {
          return true;
        } else {
          return false;
        }
      case "password":
        if (
          checkInitialState(name).valueOf(true) &&
          status &&
          isvalid.user_name.valid &&
          isvalid.customer_code.valid &&
          isvalid.processor_name.valid
        ) {
          return true;
        } else {
          return false;
        }
      case "customer_code":
        if (
          checkInitialState(name).valueOf(true) &&
          status &&
          isvalid.password.valid &&
          isvalid.user_name.valid &&
          isvalid.processor_name.valid
        ) {
          return true;
        } else {
          return false;
        }
      case "processor_name":
        if (
          checkInitialState(name).valueOf(true) &&
          status &&
          isvalid.password.valid &&
          isvalid.customer_code.valid &&
          isvalid.user_name.valid
        ) {
          return true;
        } else {
          return false;
        }
      default:
        return;
    }
  };
  const handleDefaultGateway = (e) => {
    const { checked, name } = e.target;
    setDataObj({ ...dataObj, [name]: checked });
  };

  return (
    <div>
      <Dialog open={isOpen} onClose={handleClose}>
        <DialogTitle className={classes.typographyStyles}>
          {action} Payment Gateway
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            value={dataObj.user_name}
            margin="normal"
            id="key"
            label="User name"
            type="text"
            fullWidth
            helperText={!isvalid.user_name.valid && isvalid.user_name.error}
            error={!isvalid.user_name.valid}
            variant="standard"
            name="user_name"
            onChange={onInputChange}
            inputProps={{
              "aria-label": "user_name_input",
            }}
          />
          <TextField
            autoFocus
            margin="normal"
            id="key"
            label="Password"
            type="password"
            fullWidth
            variant="standard"
            name="password"
            helperText={!isvalid.password.valid && isvalid.password.error}
            error={!isvalid.password.valid}
            value={dataObj.password}
            onChange={onInputChange}
            inputProps={{
              "aria-label": "password_input",
            }}
          />
          <TextField
            autoFocus
            margin="normal"
            id="key"
            label="Customer Code"
            type="text"
            fullWidth
            variant="standard"
            name="customer_code"
            helperText={
              !isvalid.customer_code.valid && isvalid.customer_code.error
            }
            error={!isvalid.customer_code.valid}
            value={dataObj.customer_code}
            onChange={onInputChange}
            inputProps={{
              "aria-label": "customer_code_input",
            }}
          />
          <FormControl fullWidth margin={"normal"}>
            <InputLabel id="demo-simple-select-label">
              Processor Name
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name="processor_name"
              inputProps={{
                "aria-label": "processor_name_input",
              }}
              fullWidth
              helperText={
                !isvalid.processor_name.valid && isvalid.processor_name.error
              }
              error={!isvalid.processor_name.valid}
              value={dataObj.processor_name}
              onChange={onInputChange}
            >
              <MenuItem value={"TSYS - Production"}>TSYS - Production</MenuItem>
              <MenuItem value={"TSYS - Pilot"}>TSYS - Pilot</MenuItem>
              <MenuItem value={"Rapid Connect v3 - Pilot"}>Rapid Connect v3 - Pilot</MenuItem>
          <MenuItem value={"Rapid Connect v3 - Production"}>Rapid Connect v3 - Production</MenuItem>
            </Select>
          </FormControl>
          <FormControl>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    name="in_use"
                    color="primary"
                    checked={dataObj.in_use}
                    onChange={handleDefaultGateway}
                    // style={{ marginLeft: "2rem" }}
                    className={classes.checkboxStyles}
                  />
                }
                key="in_use"
                label={
                  <Typography
                    variant="body1"
                    className={classes.typographyStyles}
                  >
                    In Use
                  </Typography>
                }
              />
            </FormGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            style={{ color: "#09c491" }}
            onClick={handleClose}
            data-testid="cancel_gateway_add_btn"
          >
            Cancel
          </Button>
          <Button
            variant="text"
            style={{ color: "#09c491" }}
            onClick={() => handleGatewayChange(dataObj, item, action)}
            disabled={!isvalid.valid}
            data-testid={`${
              action === "Edit" ? "update" : "add"
            }_gateway_info_btn`}
          >
            {action === "Edit" ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default GatewayModal;
